<template>
  <div class="operat">
    <Header/>
    <div class="content">
      <div class="menu">
        <el-menu
          default-active="1-1"
          @select="handleSelect"
          class="el-menu-vertical-demo">
          <el-submenu index="1">
            <template slot="title">
              <i class="iconfont icon-rizhi" style="margin-right:5px;"></i>
              <span>日志统计</span>
            </template>
            <el-menu-item index="1-1">访问量和下载量统计</el-menu-item>
            <el-menu-item index="1-2">生产和汇交统计</el-menu-item>
            <el-menu-item index="1-3">资源申请统计</el-menu-item>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <i class="iconfont icon-quanxian" style="margin-right:5px;"></i>
              <span>权限</span>
            </template>
            <el-menu-item index="2-1">部门管理</el-menu-item>
            <el-menu-item index="2-2">用户管理</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="viewer">
        <div class="loc">
          <span>当前位置:</span>
          <el-breadcrumb class="bre" separator="/">
            <el-breadcrumb-item :to="{ path: '/operat' }">运维管理</el-breadcrumb-item>
            <el-breadcrumb-item>{{loc.t1}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{loc.t2}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="whi">
          <ViewsDowns v-if="currentKey==='1-1'"/>
          <Output v-if="currentKey==='1-2'"/>
          <Resource v-if="currentKey==='1-3'"/>
          <iframe v-if="isIframe" :src="iframeUrl" frameborder="0"></iframe>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import ViewsDowns from "./Log/Views_downs.vue"
import Resource from "./Log/Resource.vue"
import Output from "./Log/Output_meet.vue"
export default {
  name: 'operat',
  components: {
    Header,
    Footer,
    Resource,
    Output,
    ViewsDowns
  },
  data() {
    return {
      isIframe:false,
      isEnglish: false,
      currentKey:'1-1',
      loc:{
        t1:'日志管理',
        t2:'访问量和下载量统计'
      }
    }
  },
  methods: {
    /**
     * @description: 菜单选择 判断是否是iframe
     * @brief: 
     * @Author: chenwei
     * @Date: 2022-09-13 13:20:27
     * @param {*} key
     * @return {*}
     */
    handleSelect(key){
      console.log(key);
      this.currentKey = key
      switch (key) {
        case '1-1':
            this.isIframe = false
            this.loc = {
              t1:'日志管理',
              t2:'访问量和下载量统计'
            }
            break;
        case '1-2':
            this.isIframe = false
            this.loc = {
              t1:'日志管理',
              t2:'生产和汇交统计'
            }
            break;
        case '1-3':
            this.isIframe = false
            this.loc = {
              t1:'日志管理',
              t2:'资源申请统计'
            }
            break;
        case '2-1':
            this.isIframe = false
            if(this.isEnglish){
              this.iframeUrl = 'http://www.orsc.hellosea.org.cn:8083/sysmanage/index-sys.html#static/org/dept/dept.html'
            }else{
              this.iframeUrl = 'http://120.196.115.131:8082/sysmanage/index-sys.html#static/org/dept/dept.html'
            }
            
            this.isIframe = true
            this.loc = {
              t1:'权限管理',
              t2:'部门管理'
            }
            break;
        
        case '2-2':
            this.isIframe = false
            if(this.isEnglish){
              this.iframeUrl = 'http://www.orsc.hellosea.org.cn:8083/sysmanage/index-sys.html#static/org/user/user.html'
            }else{
              this.iframeUrl = 'http://120.196.115.131:8082/sysmanage/index-sys.html#static/org/user/user.html'
            }
            
            this.isIframe = true
            this.loc = {
              t1:'权限管理',
              t2:'用户管理'
            }
            break;
    
        default:
            this.isIframe = false
            break;
      }
    }
  },
  computed: {
  },
  mounted() {
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
  },
  created() {
  }
}
</script>

<style lang="scss" scoped>
iframe{
  width: 100%;
  min-height: 650px;
}
/deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
    color: rgba(36, 126, 229, 1);
}
.loc{
  height: 60px;
  width: 100%;
  padding-left: 50px;;
  background-color: white;
  display: flex;
  align-items: center;


  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #949EB3;
  .bre{
    margin-top: 2px;
    margin-left: 12px;
  }
}
.operat{
  background-color: #F9F9F9;
}
.content{
  position: relative;
  display: flex;
  justify-content: space-between;
}
.menu{
  width: 290px;
  background: white;
}
.viewer{
  width: calc(100% - 290px);
  padding: 0 8px;
  background: #F9F9F9;
  .whi{
    margin-top: 8px;
    min-height: 500px;
    background-color: white;
    padding: 0 50px;
  }
}
/deep/ .el-menu-vertical-demo{
  width: 289px;
}
/deep/ .el-menu{
  border-right: none;
}
</style>